/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentoSpuntaDTO { 
    id?: string;
    tipo?: DocumentoSpuntaDTOTipoEnum;
    obbligatoria?: boolean;
    testo_it?: string;
    ordine?: number;
}
export enum DocumentoSpuntaDTOTipoEnum {
    ACCETTO = 'ACCETTO',
    HO_LETTO = 'HO_LETTO',
    ACCONSENTO = 'ACCONSENTO'
};



